//韩语
export default {
    首页:"첫 장",
    我的资产:"내 자산",
    重置登录密码:"로그인 비밀번호 재설정",
    重置登录密码后:"로그인 비밀번호를 재설정한 후 24시간 이내에는 현금 인출 및 OTC 이체가 금지됩니다.",
    请选择:"선택해주세요",
    密码在:"비밀번호는 6~16자 이내로 숫자와 문자로 구성됩니다.",
    请确认密码:"비밀번호를 확인해 주세요",
    产品列表:"상품 목록",
    币种:"통화",
    期限:"용어",
    订单列表:"주문 목록",
    交易用:"거래용",
    立即入金开始您的第一笔交易:"첫 번째 거래를 시작하려면 지금 돈을 입금하세요",
    立即入金:"지금 입금하세요",
    币种对:"통화쌍",
    涨幅:"증가하다",
    交易量:"거래량",
    欢迎登录:"로그인해주세요",
    登录:"로그인",
    新用户注册:"신규 사용자 등록",
    总资产折合:"전환된 총 자산",
    冻结:"꼭 매달리게 하다",
    折合:"변환됨",
    充值币种:"통화 충전",
    充值数量:"충전 수량",
    确认信息:"정보 확인",
    充币网络:"예금 네트워크",
    欢迎注册:"등록을 환영합니다",
    点击打开:"열려면 클릭하세요",
    这是一段信息:"이건 정보글이에요",
    提币数量:"인출된 코인의 양",
    提币:"코인 출금",
    百万用户首选:"수백만 명의 사용자가 선택한 첫 번째 선택",
    小时成交量:"24시간 거래량",
    优质数字资产:"고품질 디지털 자산",
    我们的核心产品:"우리의 핵심 제품",
    你可以选择丰富的交易方式:"다양한 거래 방법 중에서 선택할 수 있습니다",
    现货:"현물 상품",
    我们提供:"우리가 제공하다",
    币种的交易服务:"통화 거래 서비스",
    合约:"계약",
    使用合约丰富你的交易体验:"계약을 사용하여 거래 경험을 풍부하게 하세요",
    赚币:"돈을 얻다",
    行业内领先收益:"업계 최고의 수익",
    多元化的产品服务:"다양한 제품과 서비스",
    选择更多:"더 많은 서비스를 선택하고 무한한 가능성을 탐색하세요",
    福利中心:"복지센터",
    完成新手任务:"초보자 작업 완료",
    会员:"회원",
    享受全网最多权益:"전체 네트워크에서 가장 많은 혜택을 누려보세요",
    社区:"지역 사회",
    在这里发现币圈财富机会:"여기에서 통화계에서 부의 기회를 찾아보세요",
    随时随地开启交易:"언제 어디서나 거래를 시작하세요",
    全面支持:"전폭적인 지원",
    和:"그리고",


    交割:"배달",
    关于我们:"회사 소개",
    账变记录:"계정 변경 기록",
    股票:"재고",
    加密货币:"암호화폐",
    加载中:"로드 중...",
    已经全部加载完毕:"모두 로드되었습니다.",
    暂无记录:"기록 없음",
    高级认证:"고급인증",
    姓名:"이름",
    请输入姓名:"이름을 입력해주세요",
    护照编号:"여권 번호",
    请输入护照编号:"여권번호를 입력해주세요",
    护照照片:"여권 사진",
    申请认证:"인증 신청",
    提示:"힌트",
    确定:"확신하는",
    提交失败:"제출 실패",
    上传失败:"업로드 실패",
    身份认证:"입증",
    身份证号:"ID 번호",
    请输入身份证号:"주민등록번호를 입력해주세요",
    身份证照片:"증명사진",
    申请认证:"인증 신청",
    修改资金密码:"펀드 비밀번호 변경",
    旧密码:"기존 비밀번호",
    请输入旧密码:"이전 비밀번호를 입력해주세요",
    新密码:"새 비밀번호",
    请输入6位数字:"6자리를 입력해주세요",
    确认新密码:"새 비밀번호를 확인하세요",
    请再次输入新密码:"새 비밀번호를 다시 입력해주세요",
    提交:"제출하다",
    请输入新密码:"새로운 비밀번호를 입력해주세요",
    请输入6位数新密码:"새로운 비밀번호 6자리를 입력해주세요",
    请确认两次密码输入一致:"입력한 두 비밀번호가 일치하는지 확인하세요.",
    修改登录密码:"로그인 비밀번호 변경",
    密码长度:"비밀번호(6~12자)",
    密码长度提示:"숫자나 문자를 포함하여 6~12자를 입력하세요.",
    客服:"고객 서비스",
    永续:"지속 가능한",
    交割:"배달",
    永续合约:"무기한 계약",
    交割合约:"배송계약",
    全仓:"전체 창고",
    开多:"길게 열다",
    开空:"오픈 쇼트",
    价格:"가격",
    开仓金额:"개시금액",
    可用金额:"사용 가능한 금액",
    合约金额:"계약금액",
    保证金:"여유",
    手续费:"수수료",
    看涨:"낙관적인",
    看跌:"약세",
    交割时间:"배달 시간",
    数量:"수량",
    持有仓位:"위치를 유지",
    当前委托:"현재 주문",
    历史订单:"역사적 명령",
    暂无数据:"데이터 없음",
    购买价:"구매 가격",
    市价: "시장 가격",
    限价: "가격 제한",
    现价:"현재 가격",
    金额:"양",
    盈亏:"이익과 손실",
    操作:"작동하다",
    平仓:"포지션 마감",
    撤单:"주문 취소",
    方向:"방향",
    剩余时间:"남은 시간",
    交割时间:"배달 시간",
    详情:"세부",
    名称:"이름",
    最新价格:"최신 가격",
    h24涨跌:"24시간 기복",
    h24涨跌幅:"24시간 증가 및 감소",
    请输入开仓金额:"개시금액을 입력해주세요.",
    请输入开仓价格:"시가를 입력해주세요",
    确定执行撤单操作:"주문을 취소하시겠습니까?",
    确定执行平仓操作:"포지션 청산 작업을 실행하시겠습니까?",
    交割合约历史:"배송계약 내역",
    历史仓位:"역사적 위치",
    到期时间:"만료일",
    闪兑:"플래시 교환",
    从:"~에서",
    最大:"최고",
    可用数量:"가능 수량",
    至:"에게",
    复制成功:"성공적으로 복사되었습니다",
    基金理财:"자금재정관리",
    托管金额:"에스크로 금액",
    总收益:"총 수익",
    当日收益:"오늘의 수입",
    托管订单:"에스크로 주문",
    规则:"규칙",
    日收益:"일일 수입",
    限额:"한계",
    周期:"주기",
    天:"하늘",
    立即买入:"지금 구매",
    购买:"구입하다",
    购买日:"구입 날짜",
    起息日:"계약 날짜",
    派息时间:"배당금 지급시기",
    每日:"일일",
    计息结束日:"이자발생 종료일",
    提前赎回:"조기상환",
    预计收益:"예상 수익",
    今日日收益:"오늘(일일수입)",
    最少可投:"최소 투자",
    最大可投:"최대 투자",
    请输入买入金额:"구매금액을 입력해주세요",
    可用金额:"사용 가능한 금액",
    请输入买入金额:"구매금액을 입력해주세요",
    质押金额:"공약금액",
    累计收益:"누적 수입",
    开始时间:"시작 시간",
    结束时间:"종료 시간",
    理财规则:"재정 규칙",
    理财规则1:"재무 관리는 USDT를 플랫폼에 위탁하여 이루어지며, 플랫폼 전문팀이 금융 차익거래를 진행하며, 참가자는 자금 보관 기간 동안 플랫폼의 재무 관리 수익의 일부를 얻을 수 있습니다.",
    收益计算:"수익 계산",
    理财规则2:"회원이 플랫폼에 10,000U를 예치하고 5일 주기로 일일 수입이 0.3%~0.5%인 금융 상품을 선택합니다. 일일 수입은 다음과 같습니다.",
    最低:"가장 낮은",
    最高:"제일 높은",
    理财规则3:"둘 다: 5일 후에 받을 수 있습니다.",
    理财规则4:"수익은 매일 분배되며, 분배된 소득은 언제든지 접근 및 출금이 가능하고 원금으로 입금되며, 만기 후에 자동으로 귀하의 계좌로 반환됩니다.",
    关于违约金:"위약금에 대하여",
    理财规则5:"만료되지 않은 원금을 양도하려는 경우에는 지체상 손해배상이 발생합니다.",
    理财规则6:"청산손해액 = 정산비율 x 잔여일수 x 투자금액",
    理财规则7:"예: 본 상품의 손해배상 정산 비율은 다음과 같습니다.",
    剩余:"남은",
    天到期投资:"만료일은 일수이며, 투자금액은",
    则:"하지만",
    违约金:"손해금",
    实际退还本金为:"반환된 실제 원금은 다음과 같습니다.",
    现货账户:"현물 계좌",
    总资产:"총 자산",
    充币:"코인 입금",
    提币:"코인 출금",
    闪兑:"플래시 교환",
    投资组合:"포트폴리오",
    冻结数量:"냉동 수량",
    帮助中心:"지원 센터",
    自选:"선택 과목",
    行情:"인용 부호",
    资金:"자금",
    资讯:"정보",
    我的:"내 거",
    交易对:"거래 쌍",
    最新价:"최신 가격",
    成交量:"용량",
    标记价格:"표시 가격",
    h24最高价:"24시간 최고가",
    h24最低价:"24시간 최저가",
    h24成交量:"24시간 거래량",
    h24交易额:"24시간 거래량",
    分时:"시간 공유",
    分1:"1점",
    分5:"5점",
    分15:"15점",
    分30:"30점",
    小时1:"1 시간",
    天1:"1 일",
    周1:"일주",
    月1:"1월",
    委托订单:"주문하다",
    最新交易:"최신 거래",
    买入:"구입하다",
    卖出:"팔다",
    时间:"시간",
    方向:"방향",
    取消自选成功:"선택을 취소했습니다.",
    添加成功:"성공적으로 추가되었습니다",
    登录:"로그인",
    账户:"계정",
    邮箱:"우편",
    手机号:"전화 번호",
    请输入账户:"계좌를 입력해주세요",
    请输入邮箱:"이메일을 입력해주세요",
    请输入手机号:"전화번호를 입력해주세요",
    密码:"비밀번호",
    请输入密码:"비밀번호를 입력 해주세요",
    忘记密码:"비밀번호를 잊으셨나요?",
    还没有账号:"아직 계정이 없습니다",
    去注册:"등록하러 가기",
    请输入登录账号:"로그인 계정을 입력해주세요",
    请输入登录密码:"비밀번호를 입력해주세요",
    登录失败:"로그인 실패",
    历史记录:"역사 기록",
    充值:"충전하다",
    提现:"철회하다",
    未审核:"검토되지 않음",
    成功:"성공",
    失败:"실패하다",
    快捷入口:"빠른 입력",
    资金密码:"펀드 비밀번호",
    登录密码:"로그인 비밀번호",
    账变记录:"계정 변경 기록",
    邀请推广:"프로모션 초대",
    通用:"만능인",
    语言:"언어",
    在线客服:"온라인 서비스",
    身份认证:"입증",
    高级认证:"고급인증",
    更多:"더",
    帮助中心:"지원 센터",
    关于我们:"회사 소개",
    退出:"그만두다",
    已提交身份认证:"신원 정보를 제출했으며 검토 중입니다.",
    您已完成身份认证:"본인 확인을 완료하셨습니다.",
    您已完成高级认证:"고급 인증을 완료했습니다.",
    确定退出登录:"정말로 로그아웃하시겠습니까?",
    资讯:"정보",
    公告:"발표",
    状态:"상태",
    已成交:"거래 완료",
    委托金额:"수수료 금액",
    剩余金额:"균형",
    订单类型:"주문 유형",
    市价委托:"시장가 주문",
    限价委托:"제한 주문",
    订单号:"주문 번호",
    委托时间:"커미션 시간",
    U本位合约历史:"U 기반 계약 내역",
    成交数量:"거래 수",
    实现盈亏:"손익 실현",
    推广记录:"승격실적",
    我的总推广:"나의 일반 프로모션",
    总充值:"총 충전",
    一代人数:"세대수",
    二代人数:"2세대 수",
    三代人数:"3세대 수",
    立即推广:"지금 홍보하세요",
    我的推广:"내 프로모션",
    用户名:"사용자 이름",
    行情:"인용 부호",
    加密货币:"암호화폐",
    外汇:"외환",
    股票:"재고",
    现货交易:"현물 거래",
    热门:"인기 있는",
    涨幅榜:"게이너 목록",
    跌幅榜:"패자 목록",
    快速充币:"빠른 입금",
    保存二维码:"QR 코드 저장",
    复制地址:"주소 복사",
    转出地址:"전출 주소(선택)",
    请输入转出地址:"송금주소를 입력해주세요",
    粘贴:"반죽",
    充币数量:"입금 금액",
    请输入充币数量:"입금액을 입력해주세요",
    区块链网络:"블록체인 네트워크",
    付款凭证:"결제 바우처 (결제 내역 스크린샷 업로드)",
    请输入充值数量:"충전금액을 입력해주세요",
    充值通道:"충전 채널",
    请选择充值币种:"충전 통화를 선택해주세요",
    官方充值通道:"공식 충전 채널",
    设置密码:"암호를 설정하세요",
    确认密码:"비밀번호 확인",
    验证码:"확인 코드",
    请输入验证码:"인증번호를 입력해주세요",
    获取验证码:"인증 코드 받기",
    重新发送:"재전송",
    邀请码:"초대 코드",
    请输入邀请码:"초대코드를 입력해주세요",
    我已阅读并同意:"읽었으며 이에 동의합니다.",
    服务条款:"서비스 약관",
    注册:"등록하다",
    已有账号:"이미 계정이 있습니다",
    去登录:"로그인으로 이동",
    请再次输入密码:"비밀번호를 다시 입력해주세요",
    请同意服务条款:"서비스 약관에 동의해주세요.",
    注册失败:"등록 실패",
    欢迎来到:"에 오신 것을 환영합니다",
    全球最大的区块链资产平台:"세계 최대의 블록체인 자산 플랫폼",
    分享二维码:"QR 코드 공유",
    链接分享:"링크 공유",
    复制:"복사",
    您的邀请码:"당신의 초대 코드",
    到数字币地址:"디지털 화폐 주소로",
    选择币种:"통화 선택",
    区块链网络:"블록체인 네트워크",
    提币说明:"출금 지침",
    提现费用:"출금 수수료",
    可到账数量:"사용 가능 수량",
    可用:"사용 가능",
    请输入支付密码:"결제 비밀번호를 입력해주세요",
    请输入提币数量:"출금금액을 입력해주세요",
    全部:"모두",
    支付密码:"결제 비밀번호",
    地址:"주소",
    委托价:"주문 가격",
    成交时间:"거래시간",
    成交金额:"회전율",
    委托中:"커미션 중",
    持仓中:"위치에 있음",
    平仓中:"포지션 청산",
    已平仓:"포지션 폐쇄",
    开仓倍数:"여러 개 열기",
    委托价格:"수수료 가격",
    收盘价:"종가",
    收益率:"수익률",
    平仓时间:"폐관 시간",
    请输入转换数量:"전환수량을 입력해주세요",
    请上传付款凭证:"결제 바우처를 업로드해주세요.",
    开盘价:"개장 가격",
    开市中:"열려 있는",
    已休市:"시장이 폐쇄되었습니다",
    美股:"미국 주식",
    平仓价:"종가",
    到期结算完成:"만기결제 완료",
    印度股票:"인도 주식",
    马来股票:"말레이 주식",
    结算中:"고정",
    越南股票:"베트남 주식",
    设置资金密码:"펀드 비밀번호 설정",
    请输入资金密码:"펀드 비밀번호를 입력해주세요",
    取消:"취소",
    确定:"확신하는",
    止损价:"손실 중지 가격",
    请输入止损价格:"손실정지가격을 입력해주세요",
    请输入止盈价格:"이익 실현 가격을 입력하세요.",
    止盈价:"이익실현 가격",
    设置止盈止损:"이익실현 및 손절매 설정",
    请输入关键词:"키워드를 입력해주세요",
    搜索结果:"검색 결과",
    添加收款方式:"결제 수단 추가",
    高级认证:"고급인증",
    历史委托:"역사위원회",
    选择区域码:"지역번호를 선택하세요",
    请上传身份证图片:"신분증 사진을 업로드해주세요",
    请上传护照照片:"여권사진을 올려주세요",
    请输入提币地址:"출금주소를 입력해주세요",
    设置语言:"언어 설정",
    最低金额: "최소 금액",
    购买金额: "구매 가격",
    请输入要搜索的国家名称: "검색하고 싶은 국가명을 입력해주세요",
    确定执行该操作: "이를 수행하려면 확인하세요.?",
    历史搜索: "과거 검색",
    现货持仓: "스팟 위치",
    永续持仓: "영구 위치",
    到期结算中: "성숙기에 정착",
    火花图: "스파크 다이어그램",
    计价单位: "판매 단위",
    您拒绝了链接: "링크를 거부했습니다.",
    连接钱包成功: "지갑 연결 성공",
    已断开钱包: "지갑 연결이 끊어졌습니다.",
    钱包切换成功: "지갑 전환 성공",
    请先安装钱包插件: "먼저 지갑 플러그인을 설치해주세요",
    连接钱包: "지갑 연결",
    交易: "거래",
    确认报价: "견적 확인",
    您将获得: "당신은 얻을 것이다",
    兑换自: "사용처:",
    汇率: "환율",
    返回: "반품",
    兑换: "교환",
    消息: "정보",
    身份证反面照片: "신분증 뒷면 사진",
    身份证正面照片: "신분증 앞면 사진",
    手持身份证照片: "신분증을 들고 있는 사진",
    划转: "옮기다",
    请输入划转数量: "이체금액을 입력해주세요(USDT)",
    邀请链接: "초대링크",
    资料总览: "데이터 개요",
    推广规则: "프로모션 규칙",
    总邀请人数: "총 초대 대상자 수",
    总佣金: "총 커미션",
    安全绑定: "보안 바인딩",
    规则1: "1.이 주소는 {type}만 허용합니다. {type}이 아닌 자산을 이 주소로 전송하지 마십시오. 그렇지 않으면 자산이 검색되지 않습니다.",
    规则2: "2.위 주소를 충전한 후 네트워크 노드의 확인을 기다려야 합니다. 네트워크 노드가 확인되면 자산이 자동으로 귀하의 계정에 도착합니다. 도착 상태를 웹사이트 공지 형식으로 알려드리겠습니다.",
    规则3: "3.충전주소는 자주 변경되지 않으며 반복적으로 충전이 가능하며, 변경사항이 있을 경우 홈페이지 공지사항을 통해 알려드리겠습니다.",

    安全中心: "보안센터",
    绑定手机号: "휴대폰 번호 바인딩",
    认证中心: "인증센터",
    身份认证: "입증",
    认证要求: "인증 요구 사항",
    政府发行的证件: "정부 발행 문서",
    功能与限制: "기능 및 제한 사항",
    无限额: "제한 없음",
    预计审核时间: "예상 검토 시간: 60분",
    开始认证: "인증 시작",
    充币规则: "입금 규칙",
    加密货币股票多类选择: "암호화폐 주식 다중 선택",
    个人中心: "개인 센터",
    充值记录: "충전기록",
    提现记录: "출금기록"
    

    
}


// WEBPACK FOOTER //
// ./src/lang/kor.js